import React, { useState } from 'react';
import { storage } from '../firebase/config';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { Box, Button, CircularProgress, Avatar } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

export default function ImageUpload({ currentUrl, onUpload, path, label, variant }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  async function handleChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const storageRef = ref(storage, path + '/' + Date.now() + '_' + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on('state_changed',
      snap => setProgress(Math.round(snap.bytesTransferred / snap.totalBytes * 100)),
      err => { console.error(err); setUploading(false); },
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        onUpload(url);
        setUploading(false);
      }
    );
  }

  if (variant === 'avatar') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar src={currentUrl} sx={{ width: 80, height: 80, fontSize: 32 }}>
          {!currentUrl && '👤'}
        </Avatar>
        <Button component="label" variant="outlined" size="small"
          startIcon={uploading ? <CircularProgress size={16} /> : <PhotoCameraIcon />}
          disabled={uploading}>
          {uploading ? progress + '%' : label || 'Ladda upp bild'}
          <input type="file" hidden accept="image/*" onChange={handleChange} />
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {currentUrl && (
        <Box component="img" src={currentUrl}
          sx={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 1 }} />
      )}
      <Button component="label" variant="outlined" size="small"
        startIcon={uploading ? <CircularProgress size={16} /> : <PhotoCameraIcon />}
        disabled={uploading}
        sx={{ color: 'text.primary', borderColor: 'divider' }}>
        {uploading ? progress + '%' : label || 'Ladda upp bild'}
        <input type="file" hidden accept="image/*" onChange={handleChange} />
      </Button>
    </Box>
  );
}